export enum EnumTipoAdiantamento {
    SemAdiantamento = 0,
    AdiantamentoSemDesconto = 1,
    AdiantamentoComDesconto = 2,
}